export default function leaveOnlyNumbers(value = '') {
  return value.replace(/[^0-9]/g, '')
}
